export enum Education {
	Unspecified = 'Unspecified',
	Basic = 'Basic',
	HighSchool = 'HighSchool',
	University = 'University',
	Other = 'Other',
	ProfessEducation = 'ProfessEducation',
}
